// extracted by mini-css-extract-plugin
export default {"l_HomeLinkLogo_main":"HomeLinkLogo_l_HomeLinkLogo_main__r-ZdX","l_HomeLinkLogo__logo_img":"HomeLinkLogo_l_HomeLinkLogo__logo_img__obTSy"};